// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"6b534a9b","52":"5733360a","305":"1a6e0fb6","410":"3f61709d","575":"0bfe4d59"}[chunkId] + ".chunk.css";
};